export default __webpack_public_path__ + "static/media/swiss-dish-mobile.0d6aca29.jpg";